"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;

var _reactIntl = require("react-intl");

var messages = (0, _reactIntl.defineMessages)({
  errorDuringRolesFetch: {
    "id": "roles.errorDuringRolesFetch",
    "defaultMessage": "An error occurred while fetching the roles."
  },
  roleName: {
    "id": "roles.roleName",
    "defaultMessage": "Name"
  },
  roleNamePlaceholder: {
    "id": "roles.roleNamePlaceholder",
    "defaultMessage": "Choose a name"
  },
  privileges: {
    "id": "roles.privileges",
    "defaultMessage": "Privileges"
  },
  updateRole: {
    "id": "roles.updateRole",
    "defaultMessage": "Update role"
  },
  deleteRole: {
    "id": "roles.deleteRole",
    "defaultMessage": "Delete role"
  },
  deleteDesc: {
    "id": "roles.deleteDesc",
    "defaultMessage": "Are you sure you want to delete this role?"
  },
  deleteDesc2: {
    "id": "roles.deleteDesc2",
    "defaultMessage": "This action cannot be undone."
  },
  addNewRole: {
    "id": "roles.addNewRole",
    "defaultMessage": "Add new role"
  },
  selectARoleToUpdateIt: {
    "id": "roles.selectARoleToUpdateIt",
    "defaultMessage": "Select a role to see or edit its details."
  },
  roleSuccessfullyCreated: {
    "id": "roles.roleSuccessfullyCreated",
    "defaultMessage": "Role was successfully created."
  },
  errorDuringRoleCreation: {
    "id": "roles.errorDuringRoleCreation",
    "defaultMessage": "There was an error while creating a role."
  },
  roleAlreadyExists: {
    "id": "roles.roleAlreadyExists",
    "defaultMessage": "A role with this name already exists."
  },
  roleSuccessfullyUpdated: {
    "id": "roles.roleSuccessfullyUpdated",
    "defaultMessage": "Role was successfully updated."
  },
  roleSuccessfullyDeleted: {
    "id": "roles.roleSuccessfullyDeleted",
    "defaultMessage": "Role was successfully deleted."
  },
  errorDuringRoleUpdate: {
    "id": "roles.errorDuringRoleUpdate",
    "defaultMessage": "There was an error while updating a role."
  },
  errorDuringRoleDeletion: {
    "id": "roles.errorDuringRoleDeletion",
    "defaultMessage": "There was an error while deleting a role."
  }
});
exports.messages = messages;
//# sourceMappingURL=roles-i18n.js.map